import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pwu2qh26pz: FaireBrandEntity = {
  token: "b_pwu2qh26pz",
  type: "brand",
  name: "True It Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/5435b8550e01f00b42b1a22448294d98f74116cfec7ff3edbd22996d275fdc33.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb6f625372bcde393c216021df91ca6a8f249d516be7e331a85bcad11f7b019a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5435b8550e01f00b42b1a22448294d98f74116cfec7ff3edbd22996d275fdc33.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb6f625372bcde393c216021df91ca6a8f249d516be7e331a85bcad11f7b019a.jpeg",
  location: "Morristown, NJ, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "Born in 2021 in Morristown, NJ, True It Naturals is a family-inspired brand dedicated to crafting pure, wholesome skincare products for families like yours. Driven by a passion for natural wellness, our products are a commitment to quality and transparency to create gentle yet effective solutions for dry and sensitive skin. We source our ingredients with utmost care, often partnering with local farms like our family bee farm in New Jersey to ensure the highest standards of purity and sustainability.\n\nOur founder, Laura Truitt, embarked on this journey after witnessing firsthand the struggles of dry, eczema-prone skin within her own family. In December 2020, she began experimenting with natural lotions in her kitchen, driven by a desire to find safer, healthier alternatives for her loved ones. Months of meticulous refinement culminated in the launch of True It Naturals, a brand built on the belief that simple, natural ingredients can make a profound difference in skin health.\n\nJoin the Journey: We invite you to experience the difference of natural skincare with True It Naturals. Our products are handcrafted with love and care, designed to nourish and protect your family's skin without harsh chemicals or unnecessary additives. From moisturizing beeswax balms to soothing body butters, discover the power of nature in every jar.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:49.631Z",
    importedBy: "entity-db-cli",
  },
};
